import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

export interface IWebmailMigrationModel {
  email: string;
  first_name: string;
  last_name: string;
  phone: string;
  password?: string;
}
@Injectable({
  providedIn: 'root'
})

export class WebmailMigrationService {
  constructor(private http: HttpClient) {}

  acceptMigration(body?: IWebmailMigrationModel) {
    return this.http.post(
      'invitation/webmail1/accept',
      body?.email ? body : {}
    ).toPromise();
  }

}
